import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/core/styles';

export const useStyles = ({
  palette: {
    text,
    common: { white },
  },
  spacing: { unit },
}: Theme) =>
  createStyles({
    content: {
      padding: `${unit * 3}px !important`,
      overflow: 'visible',
      '&$hidden': {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        minHeight: 235,
      },
      backgroundColor: white,
    },
    hidden: {
      display: 'none',
    },
    text: {
      color: text.primary,
      fontWeight: 500,
    },
  });
